import * as React from "react";
import { render } from "react-dom";
import { App } from "./App";
import { APP_ROOT } from "./const";

const root = document.getElementById(APP_ROOT);
if (root) {
  render(<App/>, root);
}



// WEBPACK FOOTER //
// ./src/client.tsx